import _ from "lodash";
import http from './../../../core/services/http.service';
import {SOURCE_INVOICES_TABLE, SOURCE_SETTLEMENTS_TABLE} from "@/modules/constants";

export default {
  namespaced: true,
  state: {
    object_uuid: null,
    object_name: null,

    loading: false,
    tableData: {
      rows: [],
    },
    modal: {
      show: false,
      object: null,
      source: null,
    },
    noteListModal: {
      show: false,
      object: null,
      source: null,
      objectName: null,
      pluralObjectName: null,
      changePermission: null,
      deletePermission: null,
      hideFooter: null,
    }
  },
  actions: {
    setData({commit}, payload) {
      return commit('setData', payload);
    },
    async getNotes({commit, state}) {
      commit('toggleNotesLoader', true);
      let response = await http.get(`/api/v1/${state.plural_object_name}/${state.object_uuid}/notes/?expand=created_by`);
      commit('toggleNotesLoader', false);
      if (response.success) {
        commit('updateNotes', response.body)
      }
      return response.body;
    },
    showNoteModal({commit}, {object = null, source} = {}) {
      commit('showNoteModal', {object: _.cloneDeep(object), source});
    },
    hideNoteModal({commit}) {
      commit('hideNoteModal');
    },
    async createNote({commit, state, dispatch}, note) {
      let response = await http.post(`/api/v1/${state.plural_object_name}/notes/?expand=created_by`, note);
      if (response.success) {

        if (state.noteListModal.source === SOURCE_INVOICES_TABLE) {
          dispatch('invoices/getTableData', null, {root: true})
        } else if (state.noteListModal.source === SOURCE_SETTLEMENTS_TABLE) {
          dispatch('settlements/getTableData', null, {root: true})
        }

        commit('addNote', response.body);
      }
      return response;
    },
    async updateNote({commit, state}, note) {
      let response = await http.put(`/api/v1/${state.plural_object_name}/notes/${note.uuid}/?expand=created_by`, note);
      if (response.success) {
        commit('updateNote', response.body);
      }
      return response;
    },
    async removeNote({dispatch, state}, note) {
      let response = await http.delete(`/api/v1/${state.plural_object_name}/notes/${note.uuid}/`);
      if (response.success) {

        if (state.noteListModal.source === SOURCE_INVOICES_TABLE) {
          dispatch('invoices/getTableData', null, {root: true})
        }

        dispatch('getNotes')
      }
      return response;
    },
    showNoteListModal({commit}, payload = {}) {
      commit('showNoteListModal', payload);
    },
    hideNoteListModal({commit}) {
      commit('hideNoteListModal');
    },
  },
  mutations: {
    updateNotes: (state, data) => state.tableData.rows = data,
    toggleNotesLoader: (state, data) => state.loading = data,
    showNoteModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideNoteModal: (state) => state.modal.show = false,
    showNoteListModal: (state, {
      object,
      source,
      objectName,
      pluralObjectName,
      changePermission,
      deletePermission,
      hideFooter
    }) => {
      state.noteListModal.show = true;
      state.noteListModal.object = object;
      state.noteListModal.source = source;
      state.noteListModal.objectName = objectName;
      state.noteListModal.pluralObjectName = pluralObjectName;
      state.noteListModal.changePermission = changePermission;
      state.noteListModal.deletePermission = deletePermission;
      state.noteListModal.hideFooter = hideFooter;
    },
    hideNoteListModal: (state) => {
      state.noteListModal.show = false
      state.noteListModal.object = null
      state.noteListModal.source = null
      state.noteListModal.objectName = null
      state.noteListModal.pluralObjectName = null
      state.noteListModal.changePermission = null
      state.noteListModal.deletePermission = null
      state.noteListModal.hideFooter = null
    },
    addNote: (state, note) => {
      state.tableData.rows.unshift(note);
    },
    updateNote: (state, note) => {
      const index = state.tableData.rows.findIndex(n => n.uuid === note.uuid);
      state.tableData.rows[index] = {...state.tableData.rows[index], ...note};
      state.tableData.rows = [...state.tableData.rows];
    },
    setData: (state, {object_uuid, object_name, plural_object_name}) => {
      state.object_uuid = object_uuid;
      state.object_name = object_name;
      state.plural_object_name = plural_object_name;
    }
  }
}
